export const skillList = [
    {
        skillName: 'HTML',
        skillUrl: 'https://i.ibb.co/3yZLV4k/html.jpg',
    },
    {
        skillName: 'CSS',
        skillUrl: 'https://i.ibb.co/DVy0Yk2/css.png',
    },
    {
        skillName: 'JavaScript',
        skillUrl: 'https://i.ibb.co/3cZCw7g/js.png',
    },
    {
        skillName: 'React',
        skillUrl: 'https://i.ibb.co/p0mVwVV/react.jpg',
    },
    {
        skillName: 'Redux',
        skillUrl: 'https://i.ibb.co/LC5HNn4/red.png',
    },
    {
        skillName: 'NodeJS',
        skillUrl: 'https://i.ibb.co/LgCcrNt/node.png',
    },
    {
        skillName: 'Java',
        skillUrl: 'https://i.ibb.co/RB5wqJ4/java.png',
    },
    {
        skillName: 'MongoDB',
        skillUrl: 'https://i.ibb.co/C5rDCTy/mongo.jpg',
    },
    {
        skillName: 'AndroidStudio',
        skillUrl: 'https://i.ibb.co/PhGXjnz/android1.png',
    },
    {
        skillName: 'MATLAB',
        skillUrl: 'https://i.ibb.co/sstM3kc/matlab.jpg',
    },
    {
        skillName: 'Firebase',
        skillUrl: 'https://i.ibb.co/hVbTyqh/fire.png',
    },
    {
        skillName: 'Java Spring Boot',
        skillUrl: 'https://i.ibb.co/r4CJXbT/spring-boot-logo.png',
    },
];
